import { render } from "./MetricTableRow.vue?vue&type=template&id=1715b81b"
import script from "./MetricTableRow.vue?vue&type=script&lang=js"
export * from "./MetricTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MetricTableRow.vue"]])

export default __exports__